import { useEnsureShipmentExistsForQuoteMutation } from '@shared/generated/graphql';
import { shipmentFromFragment } from '@shared/graphql/fromFragments/shipment';
import { useEffect } from 'react';

type UseEnsureShipmentExistsForQuoteProps = {
  quoteId: string;
};

export function useEnsureShipmentExistsForQuote({
  quoteId,
}: UseEnsureShipmentExistsForQuoteProps) {
  const [ensureShipmentExistsForQuote, { data, loading }] =
    useEnsureShipmentExistsForQuoteMutation();

  useEffect(() => {
    ensureShipmentExistsForQuote({ variables: { input: { quoteId } } });
  }, [ensureShipmentExistsForQuote, quoteId]);

  const shipment = shipmentFromFragment(
    data?.ensureShipmentExistsForQuote.shipment
  );

  return {
    shipment,
    isLoading: loading,
  };
}
